import React from 'react';
import { styled } from '@glitz/react';
import { ContentArea } from '@polarnopyret/scope-episerver';
import { ResponsiveSize, ArticleTag, H2 } from 'Shared/SharedComponents/atoms/Typography';
import Link from 'Shared/Link';
import ArticleListItemViewModel from 'Shared/ViewModels/ContentListItemViewModel.type';
import ListContentViewModel from 'Shared/Blocks/ListContent/ListContentViewModel.type';
import { GridWrap } from 'Shared/PageLayout';
import { Preset, Ratio, RatioPicture } from 'Shared/Image/Ratio';

import { createGridClasses } from 'Shared/grid';
import * as style from 'Shared/Style';

const ListContentWrap = styled.div({
  marginBottom: '40px',
  ['@media ' + style.mediaMinLarge]: {
    marginBottom: '80px',
  },
})

const GridRowContentWrap = styled(GridWrap, {
  marginBottom: '40px',
  ['@media ' + style.mediaMinLarge]: {
    marginBottom: '80px',
  },
})

const GridRowLink = styled(Link, {
  textDecoration: 'none',
  color: 'black',
  width: '100%',
})

const GridRowLinkImage = styled(RatioPicture, {
  marginBottom: '16px',
})

const GridRowItemWrap = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '12px',
  ['@media ' + style.mediaUpToLarge]: {
    padding: {
      top: '0px',
      right: '16px',
      bottom: '0px',
      left: '0px',
    },
  },
})

const GridRowContent = (props: {
  articles: ArticleListItemViewModel[];
  listContent: ListContentViewModel;
  isCompact: boolean;
}) => {
  const { articles, listContent, isCompact } = props;

  if (listContent) {
    return (
      <ListContentWrap>
        <ContentArea items={listContent.content.items} />
      </ListContentWrap>
    );
  }

  return (
    <GridRowContentWrap className='grid'>
      {articles.map((article, index) => (
        <GridRowLink
          className={createGridClasses(12, 4)}
          key={index}
          to={article.url}
          draggable={false}
        >
          <GridRowLinkImage
            src={article.image?.url}
            title={article.name}
            alt={article.name}
            ratio={Ratio.FourToThree}
            preset={Preset.MagazineListItem}
            borderRadius={8}
          />
          <GridRowItemWrap>
            <ArticleTag upperCase shouldAlwaysClaimHeight>
              {article.tag}
            </ArticleTag>
            <H2 upperCase={false} fontSize={ResponsiveSize.D24_M24} shouldAlwaysClaimHeight>
              {article.heading}
            </H2>
            {article.tags?.length > 0 && (
              <ArticleTag upperCase shouldAlwaysClaimHeight>
                {article.tags?.slice(0, 3).join(', ')}
                {(article?.tags?.length ?? 0) > 3 && `, +${article?.tags?.length - 3}`}
              </ArticleTag>
            )}
          </GridRowItemWrap>
        </GridRowLink>
      ))}
    </GridRowContentWrap>
  );
};

export default GridRowContent;